import { StyleSheet, } from '@react-pdf/renderer';

export const styles = StyleSheet.create({

  page: {
    padding: 40,
    fontSize: 10,
    fontFamily: 'Helvetica',
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 10,
  },
  logo: {
    width: 40,
    height: 40,
    marginRight: 20
  },
  title: {
    fontSize: 14,
    fontWeight: 'bold',
    textAlign: 'center',
    flexGrow: 1,
  },
  subtitle: {
    fontSize: 14,
    fontWeight: 'bold',
    textAlign: 'center',
    marginTop: 2,
  },
  infoRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 2,
    fontSize: 11,
  },
  label: {
    fontWeight: 'bold',
  },
  section: {
    marginTop: 10,
    marginBottom: 10,
  },
  table: {
    borderWidth: 1,
    borderColor: '#000',
    borderStyle: 'solid',
    marginTop: 10
  },
  tableRow: {
    flexDirection: 'row',
  },
  tableRowEven: {
    backgroundColor: '#d5d5d5',
    flexDirection: 'row',
  },
  tableHeader: {
    backgroundColor: '#e0e0e0',
    fontWeight: 'bold',
  },

  tableCell: {
    // flex: 1,
    textAlign: 'center',
    borderRightWidth: 1,
    borderColor: '#000',
    padding: 3,
  },

  tableCellDate: {
    width: '8%',
  },
  tableCellTime: {
    width: '15%',
  },
  tableCellJustification: {
    width: '62%',
    borderRightWidth: 0,
  },

  rodapemessage: {
    marginTop: 5,
    fontSize: 11,
    flexGrow: 1,
  },

  assinaturaRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 10,
  },
  assinaturaBox: {
    width: '45%',
    textAlign: 'center',
  },
  assinaturaLine: {
    marginBottom: 4,
    borderBottomWidth: 1,
    borderColor: '#000',
  },
  qrCodeBox: {
    position: 'absolute',
    bottom: 40,
    right: 40,
    width: 80,
    height: 80,
    border: '1 solid #000',
    fontSize: 8,
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    paddingTop: 30,
  },
  diahoje: {
    position: 'absolute',
    bottom: -20,
    right: 200,
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },
});